import { render, staticRenderFns } from "./adminWait.vue?vue&type=template&id=0e70a809&scoped=true"
import script from "./adminWait.vue?vue&type=script&lang=js"
export * from "./adminWait.vue?vue&type=script&lang=js"
import style0 from "./adminWait.vue?vue&type=style&index=0&id=0e70a809&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e70a809",
  null
  
)

export default component.exports